import { useState, useEffect, useCallback } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import ProjectsDashboard from "./components/ProjectsDashboard";
import ProjectEditor from "./components/ProjectEditor";
import PublicViewer from "./components/PublicViewer";
import LoginPage from "./components/LoginPage";
import { Toaster } from "./components/ui/toaster";

const API_URL = process.env.REACT_APP_BACKEND_URL;

function ProtectedRoute({ token, children }) {
  if (!token) return <LoginPage onLogin={() => window.location.reload()} />;
  return children;
}

function App() {
  const [token, setToken] = useState(localStorage.getItem('admin_token'));
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('admin_token');
    if (!stored) { setChecking(false); return; }
    fetch(`${API_URL}/api/auth/verify`, {
      headers: { Authorization: `Bearer ${stored}` },
    }).then(res => {
      if (!res.ok) { localStorage.removeItem('admin_token'); localStorage.removeItem('admin_email'); setToken(null); }
    }).catch(() => {
      localStorage.removeItem('admin_token'); localStorage.removeItem('admin_email'); setToken(null);
    }).finally(() => setChecking(false));
  }, []);

  const handleLogin = useCallback((newToken) => {
    setToken(newToken);
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_email');
    setToken(null);
  }, []);

  if (checking) {
    return <div className="min-h-screen bg-slate-50 flex items-center justify-center"><div className="text-slate-400 text-sm">Loading...</div></div>;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={
            <ProtectedRoute token={token}><ProjectsDashboard token={token} onLogout={handleLogout} /></ProtectedRoute>
          } />
          <Route path="/edit/:slug" element={
            <ProtectedRoute token={token}><ProjectEditor token={token} onLogout={handleLogout} /></ProtectedRoute>
          } />
          <Route path="/view/:slug" element={<PublicViewer />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
